export * from './ionic-angular4-cache.service';
export * from './ionic-angular4-cache.module';
//# sourceMappingURL=index.js.map